import { Component } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;

@Component({
  selector: 'app-form-validation',
  templateUrl: './form-validation.component.html',
  styleUrls: ['./form-validation.component.scss']
})
export class FormValidationComponent {
  focusedElement;
  focusPassword;
  floatlabel;
  private utility;
  constructor(
    utility:Utility
  ) {
    this.utility = utility;
  }


  onFocusForElement(element) {
    this.floatlabel = true;
    if (this.focusedElement !== element) {
      this.focusedElement = element
    }
    if(element === 'pwd' || element === 'password') {
      this.focusPassword = true;
    }

    // New registration IOS bug fix
    if(element === 'termsNcondition' || element === 'emailAndMobileSubscribed') {
      $(".reg_wrap").removeClass("keyboard-open");
    } else {
      $(".reg_wrap").addClass("keyboard-open");
    }
  }

  shouldShowMblErrors(fieldName, formName) {
    return  this.utility.shouldShowErrors(fieldName, formName);
  }
  onFocusOutForElement() {
    this.focusedElement = undefined;
    this.focusPassword = false;
    this.floatlabel = false;

    // New registration IOS bug fix
    $(".reg_wrap").removeClass("keyboard-open");
  }
  getFormFiledClass(fieldName, formName, isSubmitted=false) {
    let checkValue = formName.controls[fieldName].value;
    if ((this.focusedElement && this.focusedElement === fieldName)) {
      return '';
    } else {
      if((this.shouldShowErrors(fieldName, formName) && isSubmitted) || (this.shouldShowErrors(fieldName, formName) && checkValue)){
        return 'has-error';
      }else if(this.isControlValid(fieldName, formName)){

        let fieldValue = formName.controls[fieldName].value;
        let fieldType = typeof(fieldValue);

        if(fieldType != 'undefined'){
          if(fieldType === 'string') {
            if(fieldValue.length > 0){
              return 'has-success';
            }
          } else if(fieldType === 'number') {
            if(fieldValue > 0){
              return 'has-success';
            }
          } else {
            return 'has-success';
          }
        }

        // if(typeof(formName.controls[fieldName].value) != 'undefined' && typeof(formName.controls[fieldName].value) == 'number'){
        //   if(formName.controls[fieldName].value > 0){
        //     return 'has-success';
        //   }
        // }
        // if(typeof(formName.controls[fieldName].value) != 'undefined' && typeof(formName.controls[fieldName].value) == 'string'){
        //   if(formName.controls[fieldName].value.length > 0){
        //     return 'has-success';
        //   }
        // }
      }
    }
  }

  shouldShowErrors(fieldName, formName) {
    if (this.focusedElement && this.focusedElement === fieldName) {
      return false;
    } else {
      return this.utility.shouldShowErrors(fieldName, formName)
    }
  }
  getErrorMessage(fieldName, formName) {
    return this.utility.getErrorMessage(fieldName, formName)
  }

  isControlValid(fieldName, formName) {
    return this.utility.isControlValid(fieldName, formName)
  }
  activeInputlabel(ele, group) {
    let value = group.value[ele];
    if(value.length > 0 ) {
      this.floatlabel = true;
    } else {
      this.floatlabel = false;
    }
    $(".arrow_box_small").show()
    $(".arrow_box").show()
  }

  hideErrors() {
    $(".arrow_box_small").hide()
    $(".arrow_box").hide()
  }
}
